import React from "react";

export const Services = (props) => {
  return (
    <div id="inne" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Zapraszamy również tutaj</h2>
          <p>
            Oprócz PartyMyBox w naszej ofercie znajdziesz jeszcze więcej kulinarnych dobroci, a także przepiękną salę bankietową
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <a href={d.link}>
                    <img src={d.icon} alt={d.name}/>
                  </a>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
